module.exports = __webpack_public_path__ + "static/logo-restaurante-borrasco-sombra-9cac41783df30d6425ef3b3916020789.png";